import { useEffect, useState } from "react";

export const TaxonomyFilter = ({
  taxonomyAll = {},
  appliedFilters = {},
  handleInputChange
}) => {
  const [search, setSearch] = useState("");
  const [expanded, setExpanded] = useState({});

  const searchText = search.trim().toLowerCase();

  const matches = (text = "") =>
    text.toLowerCase().includes(searchText);

  const toggle = (key) =>
    setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));

  // 🔹 Auto-expand when searching
  useEffect(() => {
    if (!searchText) return;

    const autoExpand = {};
    Object.entries(taxonomyAll).forEach(([type, data]) => {
      autoExpand[type] = true;
      data.disciplines?.forEach((d) => {
        autoExpand[d._id] = true;
      });
    });

    setExpanded(autoExpand);
  }, [searchText, taxonomyAll]);

  // 🔹 Filter tree
  const filteredTaxonomy = Object.entries(taxonomyAll)
    .map(([vendorType, data]) => {
      const disciplines = data.disciplines
        ?.map((disc) => {
          const categories = disc.categories
            ?.map((cat) => {
              const subCategories = cat.subCategories?.filter((s) =>
                matches(s.name)
              );

              if (matches(cat.name) || subCategories?.length) {
                return { ...cat, subCategories };
              }
              return null;
            })
            .filter(Boolean);

          if (matches(disc.name) || categories?.length) {
            return { ...disc, categories };
          }
          return null;
        })
        .filter(Boolean);

      if (matches(vendorType) || disciplines?.length) {
        return { vendorType, disciplines };
      }
      return null;
    })
    .filter(Boolean);

  return (
    <div className="space-y-2">

      {/* SEARCH */}
      <input
        type="text"
        className="w-full border rounded px-2 py-1 text-xs"
        placeholder="Search vendor category"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {/* SCROLLABLE AREA */}
      <div className="max-h-64 overflow-y-auto pr-1 space-y-3">

        {filteredTaxonomy.length === 0 && searchText && (
          <p className="text-xs text-gray-400 text-center mt-2">
            No matching categories found
          </p>
        )}

        {filteredTaxonomy.map(({ vendorType, disciplines }) => (
          <div key={vendorType} className="space-y-2">

            {/* VENDOR TYPE */}
            <p
              className="font-semibold text-sm text-gray-900 cursor-pointer"
              onClick={() => toggle(vendorType)}
            >
              {vendorType}
            </p>

            {expanded[vendorType] &&
              disciplines.map((disc) => (
                <div key={disc._id} className="ml-3 space-y-2">

                  {/* DISCIPLINE */}
                  <p
                    className="text-sm font-semibold text-gray-800 cursor-pointer"
                    onClick={() => toggle(disc._id)}
                  >
                    {disc.name}
                  </p>

                  {expanded[disc._id] &&
                    disc.categories.map((cat) => (
                      <div
                        key={cat._id}
                        className="ml-3 space-y-2"
                      >

                        {/* CATEGORY */}
                        <label className="flex items-center gap-2 text-sm font-medium text-gray-700 hover:bg-gray-100 px-1 py-0.5 rounded">
                          <input
                            type="checkbox"
                            className="mt-[1px]"
                            checked={appliedFilters.vendorCategory?.includes(cat._id)}
                            onChange={() =>
                              handleInputChange(
                                "vendorCategory",
                                cat._id,
                                true
                              )
                            }
                          />
                          {cat.name}
                        </label>

                        {/* SUB-CATEGORIES */}
                        {cat.subCategories?.map((sub) => (
                          <label
                            key={sub._id}
                            className="flex items-center gap-2 ml-6 text-xs text-gray-600 hover:bg-gray-50 px-1 py-0.5 rounded"
                          >
                            <input
                              type="checkbox"
                              className="mt-[1px]"
                              checked={appliedFilters.vendorCategory?.includes(sub._id)}
                              onChange={() =>
                                handleInputChange(
                                  "vendorCategory",
                                  sub._id,
                                  true
                                )
                              }
                            />
                            {sub.name}
                          </label>
                        ))}
                      </div>
                    ))}
                </div>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
};
